import UnauthorizedModal from './UnauthorizedModal.container';

export default UnauthorizedModal;
